export default function rulesattendance(state = [], action) {
    switch (action.type) {
        case 'ADD_CURRENT':
            return {
                ...state,
                rulesattendance: action.rulesattendance,
            }
        default:
            return state;
    }
}
